var exports = {
  "AS": "x61f99309--421ebd--item",
  "oT": "x61f99309--421ebd--item-container",
  "K1": "x61f99309--421ebd--item--active",
  "Eg": "x61f99309--421ebd--starred-badge",
  "kv": "x61f99309--421ebd--checkbox",
  "Xh": "x61f99309--421ebd--username",
  "pq": "x61f99309--421ebd--info",
  "sh": "x61f99309--421ebd--common",
  "iU": "x61f99309--421ebd--message",
  "UU": "x61f99309--421ebd--name",
  "Qq": "x61f99309--421ebd--text",
  "c1": "x61f99309--421ebd--multiline",
  "zH": "x61f99309--421ebd--details",
  "Te": "x61f99309--421ebd--texts",
  "Mm": "x61f99309--421ebd--chat-info",
  "hJ": "x61f99309--421ebd--counter",
  "Xe": "x61f99309--421ebd--item-swipe--no-display",
  "fj": "x61f99309--421ebd--right-swipe-button",
  "JW": "x61f99309--421ebd--left-swipe-button--shown",
  "lJ": "x61f99309--421ebd--item-swipe--display",
  "Pc": "x61f99309--421ebd--item-swipe--hidden",
  "Pu": "x61f99309--421ebd--item-swipe--visible",
  "UY": "x61f99309--421ebd--left-swipe-button",
  "hi": "x61f99309--421ebd--preview-container",
};

module.exports = exports;
